import { iconBaseProps, type IconProps } from "@/components/ui/icons/icon-base"

export const ImageIcon = ({ size = 16, ...props }: IconProps) => (
  <svg {...iconBaseProps(size, props)} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="9" cy="9" r="2" />
    <path d="m21 15-3.5-3.5a2 2 0 0 0-2.8 0L6 20" />
  </svg>
)
